module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"notFound":""},"en":{"notFound":"Plot not found"},"it":{"notFound":"Trama non trovata"},"lt":{"notFound":""},"pl":{"notFound":""}}')
  delete Component.options._Ctor
}
